export default __webpack_public_path__ + "static/media/archive-icon.eddfddb8.svg";